import { Controller } from 'stimulus';

const CLASS_STICKY = 'amba-sticky-element--stuck';

/**
 * Attach to a position: sticky; element and apply
 * a class when it's "stuck"
 *
 * This only works for elements that are sticky at the top
 * of the page. The rootMargin value means that the element
 * will intersect with the top of the page.
 * This'll need refactoring if it's to be used with other
 * positions
 */
export default class extends Controller {
  static values = {
    topOffset: { type: Number, default: 0 },
  };

  connect() {
    this.observer = new IntersectionObserver(
      ([e]) => {
        e.target.classList.toggle(CLASS_STICKY, e.isIntersecting);
      },
      {
        rootMargin: `-${this.topOffsetValue}px 0px -100%`,
      }
    );

    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.unobserve(this.element);
  }
}
